"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const type_1 = require("../type");
const Grid_1 = __importDefault(require("../../layout/Grid/Grid"));
function helpList(start) {
    const x = [];
    const y = [];
    const z = [];
    for (let i = start; i < start + 15; i++) {
        if (x.length !== 5) {
            x.push(i);
        }
        else if (y.length !== 5) {
            y.push(i);
        }
        else {
            z.push(i);
        }
    }
    return [x, y, z];
}
const numMap = [
    [1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1],
    [1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1],
    [1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1],
    [1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1],
    [1, 1, 1, 0, 0, 0, 0, 1, 0, 0, 1, 1, 1, 1, 1],
    [1, 1, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1],
    [1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1],
    [1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 0, 0, 0],
    [1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1],
    [1, 1, 1, 0, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1], // 9
];
function FNumber(props) {
    const { start, num, second } = props;
    const he = (0, react_1.useMemo)(() => helpList(start), [start]);
    const gap = 2;
    const cur = numMap[num];
    return (react_1.default.createElement(Grid_1.default, { className: "glx-f-number", flex: true, flexR: true, gap: gap }, he.map((i, indI) => {
        return (react_1.default.createElement(Grid_1.default, { flex: true, flexC: true, gap: gap }, i.map((j, indJ) => {
            const ii = indI * 5 + indJ;
            return (react_1.default.createElement(Grid_1.default, { className: [
                    [cur[ii] === 1, 'num-active'],
                    [ii === second, 'num-active--secondary'],
                ] }, (0, type_1.pad)(j)));
        })));
    })));
}
exports.default = FNumber;
FNumber.defaultProps = {
    second: undefined,
};
